// extracted by mini-css-extract-plugin
export default {"zoomModal":"V2-z"};